import { graphql } from '@e-socna/data-layer';

export const FileExplorer_FileCategoryAccess_Fragment = graphql(`
  fragment FileExplorer_FileCategoryAccess_Fragment on FileCategoryAccess {
    fileCategoryId
    download {
      ...Access_Answer_Fragment
    }
    upload {
      ...Access_Answer_Fragment
    }
  }
`);
